/**
 * Hybrid Duration Component
 * Automatically chooses between Tailwind and styled-components based on props
 */

import React from "react";
import type { TypeTextProps } from "@sproutsocial/seeds-react-text";
import { Container } from "./styles"; // Styled-components version (named export)
import { DurationTailwind } from "./DurationTailwind"; // Tailwind version
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";

export const DurationHybrid = React.forwardRef<HTMLSpanElement, TypeTextProps>(
  (props, ref) => {
    // styled-system props (e.g. color, fontSize) must render through the
    // styled-components Container so those styles apply. Everything else uses the
    // Tailwind path — a styled(Duration) extension still works there because
    // styled() forwards its generated className onto the rendered element.
    if (hasStyledProps(props)) {
      return <Container ref={ref} {...props} />;
    }

    // Use Tailwind version (preferred - better performance)
    return <DurationTailwind ref={ref} {...props} />;
  }
);

DurationHybrid.displayName = "DurationHybrid";
